













import mixins from 'vue-typed-mixins';
import NotificationForm from '@/components/notification/NotificationForm.vue';
import NotificationUtils, { Notification } from '@/utils/NotificationUtils';
export default mixins().extend({
  components: {
    NotificationForm,
  },

  data(): {
    item?: Partial<Notification>;
  } {
    return {
      item: {
        id: undefined,
        name: undefined,
        text: this.$languageobj(),
        datepublished: undefined,
      },
    };
  },

  methods: {
    async save() {
      if (this.item) {
        try {
          this.$alert.hide('save');
          this.item = await NotificationUtils.api.add(this.item);
          await this.$router.push({ name: 'notification' });
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.add', {
              values: [this.item?.name],
            }),
          });
        } catch (error) {
          this.$alert.show('save', {
            type: 'error',
            messages: this.$handleAPIError(error),
          });
        }
      }
    },
  },
});
